// Core identity fields are system-owned and NOT part of templates:
// firstName, lastName, email, phone

export type FieldType =
  | "text"
  | "number"
  | "date"
  | "select"
  | "checkbox"
  | "textarea"
  | "heading"
  | "certification"
  // Read-only, system-populated section showing registration/identity data
  // (first name, last name, email, phone) already collected at sign-up. No
  // user input, no options. Owner pages render it live from the session user;
  // admin view renders the JSON snapshot persisted into data[fieldKey].
  | "registration";

  export interface VisibilityRule {
    fieldKey: string;
    operator: "equals" | "notEquals";
    value: string;
  }
  export interface ProfileField {
  key: string;                 // e.g. "dob", "hstNumber"
  label: string;               // Admin-editable prompt
  helper?: string;             // Small helper text
  type: FieldType;             // How it renders
  required: boolean;           // Template-controlled
  options?: string[];          // For select fields

  minLength?: number;
  maxLength?: number;
  mask?: string;

  // When true, the value is encrypted at-rest (AES-256-GCM, profile-specific
  // key from Key Vault) and rendered masked. Reveal requires the
  // `profiles.sensitive` permission and produces an audit log entry. Toggle
  // is item-level metadata — no new field type, no schema migration.
  sensitive?: boolean;

  visibleWhen?: VisibilityRule[];
}

export interface ProfileStep {
  id: number;
  label: string;
  scope: "public" | "internal";
  fields: ProfileField[];
}


export interface ProfileTemplate {
  id: string;                  // "employee", "supplier"
  name: string;                // Display name
  version: number;
  status: "active" | "draft";
  steps: ProfileStep[];
}

// System (default) templates seeded for SMRT-Docs orgs. Identified by name —
// they can be edited but not deleted or renamed (backend enforces this; the UI
// hides the affordances). Keep in sync with the backend
// SYSTEM_PROFILE_TEMPLATE_NAMES in systemProfileTemplates.ts.
export const SYSTEM_TEMPLATE_NAMES = ["Employee", "Collaborator", "Delegate"] as const;

export function isSystemTemplate(name: string | undefined | null): boolean {
  return !!name && (SYSTEM_TEMPLATE_NAMES as readonly string[]).includes(name);
}
